import { Text, IconButton, Tooltip, Flex } from '@radix-ui/themes';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';
import { formatDate } from './utils';
import styles from './Changelog.module.css';

const ReleaseCard = ({ release, canEdit, onEdit, onDelete }) => {
  return (
    <div className={styles.releaseCard}>
      <div className={styles.releaseHeader}>
        <span className={styles.date}>{formatDate(release.released_at)}</span>
        {canEdit && release.status === 'draft' && (
          <span className={styles.draftBadge}>Draft</span>
        )}
        {canEdit && (
          <Flex gap="1" align="center" style={{ marginLeft: 'auto' }}>
            <Tooltip content="View">
              <IconButton variant="outline" size="2" color="gray" asChild>
                <a href={`/client_admin/changelog/${release.id}`}>
                  <i className="fa-light fa-eye fa-lg" />
                </a>
              </IconButton>
            </Tooltip>
            <Tooltip content="Edit">
              <IconButton
                variant="outline"
                size="2"
                color="gray"
                onClick={() => onEdit(release)}
              >
                <i className="fa-light fa-pen-to-square fa-lg" />
              </IconButton>
            </Tooltip>
            <Tooltip content="Delete">
              <IconButton
                variant="outline"
                size="2"
                color="gray"
                onClick={() => onDelete(release)}
              >
                <i className="fa-light fa-trash fa-lg" />
              </IconButton>
            </Tooltip>
          </Flex>
        )}
      </div>
      {release.title && (
        <Text className={styles.title} size="4" weight="medium">
          {release.title}
        </Text>
      )}
      {release.body && (
        <div className={styles.body}>
          <Markdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw, rehypeSanitize]}
            components={{
              a: ({ children, ...props }) => (
                <a {...props} target="_blank" rel="noopener noreferrer">
                  {children}
                </a>
              ),
            }}
          >
            {release.body}
          </Markdown>
        </div>
      )}
    </div>
  );
};

export default ReleaseCard;
